export default __webpack_public_path__ + "mention-over-coffee.png";